import { useAtom } from "jotai";
import { useMemo } from "react";

import {
  landerCplQuizAtom,
  landerCplQuizGrantedEntriesAtom,
} from "../../../lander-cpl-quiz/lander-cpl-quiz.state";
import { QuizProgressBar } from "../../../shared/components/lander-quiz-components/quiz-progress-bar/quiz-progress-bar.component";
import { getQuestionsAnsweredCount } from "../../utils";
import {
  videoAdsGrantedEntriesCounterAtom,
  videoAdsQuizQuestionsAtom,
} from "../../video-ads-quiz.state";

export const VideoAdsQuizHeader: React.FC = () => {
  const [landerCplQuiz] = useAtom(landerCplQuizAtom);
  const [videoAdsQuiz] = useAtom(videoAdsQuizQuestionsAtom);
  const [entriesCounter] = useAtom(videoAdsGrantedEntriesCounterAtom);
  const [landerCplQuizGrantedEntries] = useAtom(
    landerCplQuizGrantedEntriesAtom
  );

  const questionsAnsweredCount = useMemo(
    () => getQuestionsAnsweredCount(videoAdsQuiz),
    [videoAdsQuiz]
  );

  const totalEntries = useMemo(
    () =>
      entriesCounter +
      (landerCplQuiz.allTimePoints ?? 0) +
      (landerCplQuizGrantedEntries ?? 0),
    [entriesCounter, landerCplQuiz.allTimePoints, landerCplQuizGrantedEntries]
  );

  return (
    <div className="video__ads__quiz__header">
      <div className="video__ads__quiz__header--earned-entries">
        {`Your entries: ${totalEntries}`}
      </div>
      <QuizProgressBar
        branchedQuestionsCount={0}
        quizQuestionsCount={landerCplQuiz.number_of_cosponsors}
        questionsAnsweredCount={questionsAnsweredCount}
      />
    </div>
  );
};
